import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';

import { FullscreenService } from './core/services/fullscreen.service';
import { SmartModalService } from './core/services/smart-modal.service';
import { DOCUMENT } from '@angular/common';
import { interval } from 'rxjs/observable/interval';

import { AuthService } from './core/services/auth.service';
import { AuthAttemptStatus } from './core/services/silent-auth.service';
import { Observable } from 'rxjs';
import { ConfigService } from './core/services/config.service';
import { LoginPromptComponent } from './core/components/login-prompt/login-prompt.component';
import { DomainService } from './core/services/domain.service';

declare var $: any;

@Component({
    selector: 'itpx-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {

    //test

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: "visible",
        rtl: false,
        animate: "scale",
        position: ["right", "bottom"]
    };

    private isFullscreen: boolean;

    constructor(
        private fullscreenService: FullscreenService,
        private smartModalService: SmartModalService,

        private authService: AuthService,
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document,
        private domainService: DomainService,
    ) { }

    ngOnInit() {
        let domain = this.domainService.getDomain()
        if (domain && domain.name === 'futureskillsprime')
            this.document.getElementById('appFavicon').setAttribute('href', './assets/primeicon.ico');
        else
            this.document.getElementById('appFavicon').setAttribute('href', 'favicon.ico');
        this.bouncerInit();
        this.smartModalService.isOpen();

        this.fullscreenService
            .onFullscreen()
            .subscribe(val => this.isFullscreen = val);
    }

    ngAfterViewInit() {
        $(function () {
            $('#scrollable-container').slimScroll({
                height: '100%',
                width: '100%'
            });
        });
    }

    private onExitFullscreenClicked() {
        this.fullscreenService.exitFullscreen();
    }


    // BOUNCER LOGIC START
    bouncerInit() {
        let ping = interval(1000 * 5).switchMap(() => this.authService.pollBouncer());

        ping.subscribe();

        ping
            .filter(_ => {
                return _ === AuthAttemptStatus.UNAUTHORIZED
            })
            .take(1)
            .map(_ => {
                this.authService.clearSession();
                this.authService.login();
            })
            // .bindToLifecycle(this)
            .subscribe();
    }

    promptForLogin(): Observable<any> {
        return this.smartModalService
            .open(LoginPromptComponent, {}, 'Logged out')
            .neverError()
            .do(_ => {
                if (_.result.action === 'login') {
                    this.authService.login();
                } else if (_.result.action === 'logout') {
                    this.authService.clearSession();
                    this.document.location.replace(`${this.configService.get('server').account}/login/${this.domainService.parseDomain()}`);
                }
            })
    }
    //  BOUNCER LOGIN END
}

export enum AuthState {
    GUEST,
    LOGGED,
    PROMPTED_FOR_RELOG
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts